<template>
  <section>
    <div class="active-handler hidden-md-and-up" @click="toggleModal">
      <i :class="showModal ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
    </div>
    <section class="mobile-sidebar-modal"
      :class="{ visible: showModal }"
      @click="toggleModal">
    </section>
    <section class="mobile-sidebar-container"
      :class="{ visible: showModal }">
      <div class="logo">
        <img :src="logo" alt="logo"/>
      </div>
      <div class="welcome-title">
        <span class="welcome-title">{{ slogan }} {{ version }}</span>
      </div>
      <el-collapse>
        <el-collapse-item title="设备类型">
          <Menus :isVerticalStyle="true"></Menus>
        </el-collapse-item>
        <el-collapse-item title="设备分组">
          <DeviceMenus></DeviceMenus>
        </el-collapse-item>
        <el-collapse-item title="监测图表">
          <Submenus :isVerticalStyle="true"></Submenus>
        </el-collapse-item>
        <el-collapse-item title="系统功能" v-if="currentAdminIsSuper">
          <SettingMenus></SettingMenus>
        </el-collapse-item>
      </el-collapse>

      <div class="welcome-title">
        <el-link icon="el-icon-user" @click="logout">
          注销 {{currentAdminUsername}}
        </el-link>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import Menus from '@/components/menus/Menus';
import Submenus from '@/components/menus/Submenus';
import DeviceMenus from '@/components/menus/DeviceMenus';
import SettingMenus from '@/components/menus/SettingMenus';

export default {
  components: {
    Menus,
    Submenus,
    DeviceMenus,
    SettingMenus,
  },
  computed: {
    ...mapGetters('meta', ['logo', 'slogan', 'version']),
    ...mapGetters('admin', ['currentAdminUsername', 'currentAdminIsSuper']),
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    // XXX 路由切换模态窗隐藏，确保页面可滚动
    document.body.classList.remove('el-popup-parent--hidden');
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      if (this.showModal) {
        // 弹出模态窗禁止页面滚动
        document.body.classList.add('el-popup-parent--hidden');
      } else {
        document.body.classList.remove('el-popup-parent--hidden');
      }
    },
    logout() {
      this.$confirm('确定要注销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then(() => {
        window.location = '/session/logout';
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables';

.active-handler {
  color: white;
  top: 0;
  left: 0;
  background-color: $logo-red;
  width: $header-height;
  height: $header-height;
  line-height: $header-height;
  text-align: center;
  font-size: $header-height * 0.66;
}
.mobile-sidebar-modal {
  display: none;
  background-color: rgba(0,0,0,.5);
  position: fixed;
  top: $header-height;
  bottom: 0;
  left: 0;
  right: 0;
  &.visible {
    display: initial;
  }
}
.mobile-sidebar-container {
  display: none;
  position: absolute;
  top: $header-height;
  width: 250px;
  height: 100vh;
  overflow-y: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #fefefe;
  color: #666;
  // transition: all .3s cubic-bezier(0,0,.2,1);
  &.visible {
    display: initial;
  }
  .logo > img {
    width: 100%;
  }
  h2 {
    font-size: 18px;
    margin: 10px 0 10px 0;
  }
  .measure-section {
    margin: 20px 0 20px 0;
    .title {
      color: #999;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .welcome-title {
    margin: 20px auto;
  }
}
</style>
